import { render, staticRenderFns } from "./IrreparableList.vue?vue&type=template&id=32f17dd5&"
import script from "./IrreparableList.vue?vue&type=script&lang=js&"
export * from "./IrreparableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports